import { SkeletonData, Spine } from "@pixi-spine/all-3.8";
import { ERoundState } from "../../core/round/interfaces";
import { GameAnimationData } from "../constants";
import { EGlowAnimationStates } from "./enums";
import { PixiApplication } from "@karma-games/angular-devkit/src/lib/modules/pixi";

export class CrocoScreenGlowGameApp extends PixiApplication {
    private glowAnimationName: Spine | undefined = undefined;
    private currentRoundState: ERoundState = ERoundState.Idle;

    override initialize(gameContainer: HTMLElement, initialRoundState: ERoundState = ERoundState.Idle): void {
        super.initialize(gameContainer);
        this.view.style.width = "100%";
        this.view.style.height = "100%";
        this.glowAnimationName = new Spine(<SkeletonData>this.loader!.resources[GameAnimationData.glowAnimationName].spineData);
        this.stage.addChild(this.glowAnimationName);
        this.glowAnimationName.visible = false;
        this.changeState(initialRoundState);
    }

    changeState(state: ERoundState): void {
        if (!this.glowAnimationName || this.currentRoundState === state) {
            return;
        }
        this.currentRoundState = state;
        switch (state) {
            case ERoundState.Idle:
                this.glowAnimationName!.visible = false;
                break;
            case ERoundState.Playing:
                this.glowAnimationName!.visible = true;
                this.glowAnimationName!.state.setAnimation(0, EGlowAnimationStates.Run, true);
                break;
            case ERoundState.Ended:
                this.glowAnimationName!.state.setAnimation(0, EGlowAnimationStates.Fall, false);
                break;
            default:
                this.glowAnimationName!.visible = false;
                break;
        }
    }
}
